import React, { useEffect, useRef } from "react";
import { ButtonIcon, Icon } from "fr-ito-web-react/react/esm";
import styles from "./styles.module.css";

const HIDDEN_STYLE: React.CSSProperties = {
  opacity: 0,
  visibility: "hidden",
  transition: "opacity 0.4s ease, visibility 0.4s ease"
};

const GoTop = () => {
  const btnRef = useRef<HTMLDivElement>(null);
  const showRef = useRef(false);
  const lastClickRef = useRef(0);

  const click = () => {
    const now = Date.now();
    if (now - lastClickRef.current < 500) return;
    lastClickRef.current = now;
    window?.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    const el = btnRef.current;
    if (!el) return () => undefined;

    const handleScroll = () => {
      if (window.pageYOffset > 2600 && !showRef.current) {
        showRef.current = true;
        el.style.opacity = "1";
        el.style.visibility = "visible";
      } else if (window.pageYOffset < 2600 && showRef.current) {
        showRef.current = false;
        el.style.opacity = "0";
        el.style.visibility = "hidden";
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div ref={btnRef} style={HIDDEN_STYLE}>
      <div className={styles.Top}>
        <ButtonIcon
          aria-label="share"
          designTokens={{
            borderColorToken: "ito-gray200-border",
            borderRadiusToken: "ito-border-radius-50-percent",
            borderWidthToken: "ito-border-width-1"
          }}
          element="button"
          icon={
            <Icon
              designTokens={{ colorToken: "ito-primary-icon-color" }}
              name="backToTop"
            />
          }
          onClick={click}
          size="medium"
        />
      </div>
    </div>
  );
};

export default GoTop;
